export default "__VITE_ASSET__CwLtHZYA__"